import React from 'react'
import T from 'prop-types'
import { Box, Stack, Typography } from '@mui/material'

const VARIANT_LIST = 'list'
const VARIANT_DETAILS = 'details'

export default function ChoiceLabel({
  variant = VARIANT_LIST,
  label,
  sublabel,
}) {
  const isDetails = variant === VARIANT_DETAILS

  return (
    <Stack
      direction={isDetails ? 'row' : 'column'}
      alignItems={isDetails ? 'center' : 'flex-start'}
      sx={{ whiteSpace: 'nowrap' }}
    >
      <Typography color="textPrimary" variant="body1">
        {label}
      </Typography>
      {isDetails && <Box pr={1} />}
      <Typography color="textSecondary" variant="body2">
        {sublabel}
      </Typography>
    </Stack>
  )
}

ChoiceLabel.propTypes = {
  variant: T.oneOf([VARIANT_LIST, VARIANT_DETAILS]),
  label: T.string.isRequired,
  sublabel: T.string,
}
